const getBrandStatus = (branding, label) =>
  branding === 'bevChain' && label === 'Awaiting Linfox' ? 'Awaiting BevChain' : label;

export { getBrandStatus };
